import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, Transition as _Transition, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/bot_express_logo.png'


const _hoisted_1 = { class: "min-h-screen bg-zinc-900 font-poppins text-zinc-100" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "Logo",
  class: "h-auto w-32 drop-shadow-glow"
}
const _hoisted_3 = {
  key: 1,
  src: "/favicon.ico",
  alt: "Logo",
  class: "h-10 w-10 drop-shadow-glow"
}
const _hoisted_4 = { class: "flex-1 space-y-1" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "pt-4 pb-2 px-3"
}
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = { class: "text-[10px] font-semibold text-zinc-500 uppercase tracking-wider" }
const _hoisted_9 = {
  key: 2,
  class: "py-2"
}
const _hoisted_10 = { class: "pt-4 mt-auto border-t border-zinc-700/30" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "mt-3 bg-zinc-800/50 rounded-lg p-2"
}
const _hoisted_14 = { class: "grid grid-cols-3 gap-1.5" }
const _hoisted_15 = {
  href: "https://instagram.com/expressoficial_bot",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "flex items-center justify-center p-2 rounded-md bg-gradient-to-br from-purple-600/10 to-pink-500/10 hover:from-purple-600/20 hover:to-pink-500/20 transition-all duration-200"
}
const _hoisted_16 = {
  href: "https://wa.me/5511918600431",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "flex items-center justify-center p-2 rounded-md bg-gradient-to-br from-[#25D366]/10 to-[#128C7E]/10 hover:from-[#25D366]/20 hover:to-[#128C7E]/20 transition-all duration-200"
}
const _hoisted_17 = {
  href: "https://t.me/botexpressoficial",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "flex items-center justify-center p-2 rounded-md bg-gradient-to-br from-blue-500/10 to-cyan-400/10 hover:from-blue-500/20 hover:to-cyan-400/20 transition-all duration-200"
}
const _hoisted_18 = {
  key: 1,
  class: "mt-3 flex flex-col items-center space-y-1.5"
}
const _hoisted_19 = {
  href: "https://instagram.com/expressoficial_bot",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "flex items-center justify-center w-9 h-9 rounded-lg bg-gradient-to-br from-purple-600/10 to-pink-500/10 hover:from-purple-600/20 hover:to-pink-500/20 transition-all duration-200"
}
const _hoisted_20 = {
  href: "https://wa.me/5511918600431",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "flex items-center justify-center w-9 h-9 rounded-lg bg-gradient-to-br from-[#25D366]/10 to-[#128C7E]/10 hover:from-[#25D366]/20 hover:to-[#128C7E]/20 transition-all duration-200"
}
const _hoisted_21 = {
  href: "https://t.me/botexpressoficial",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "flex items-center justify-center w-9 h-9 rounded-lg bg-gradient-to-br from-blue-500/10 to-cyan-400/10 hover:from-blue-500/20 hover:to-cyan-400/20 transition-all duration-200"
}
const _hoisted_22 = {
  class: "mobile-bottom-navigation fixed bottom-0 left-0 right-0 bg-zinc-900/95 backdrop-blur-lg border-t border-white/5 z-30 lg:hidden",
  style: {"box-shadow":"0 -10px 20px rgba(0, 0, 0, 0.3)"}
}
const _hoisted_23 = { class: "flex justify-between items-center px-2 h-16" }
const _hoisted_24 = {
  key: 0,
  class: "absolute -top-3 w-10 h-1 rounded-full bg-gradient-to-r from-emerald-500 to-teal-500 shadow-glow-sm"
}
const _hoisted_25 = { class: "text-xs font-medium" }
const _hoisted_26 = {
  key: 0,
  class: "absolute -top-3 w-10 h-1 rounded-full bg-gradient-to-r from-emerald-500 to-teal-500 shadow-glow-sm"
}
const _hoisted_27 = {
  key: 0,
  class: "fixed inset-x-0 bottom-0 z-50 lg:hidden",
  style: {"box-shadow":"0 -10px 40px rgba(0, 0, 0, 0.5)","max-height":"85dvh"}
}
const _hoisted_28 = {
  class: "bg-zinc-800 rounded-t-3xl overflow-hidden border-t border-l border-r border-emerald-500/10 h-full flex flex-col",
  style: {"max-height":"80dvh"}
}
const _hoisted_29 = { class: "flex justify-between items-center px-6 py-4 border-b border-zinc-700/50" }
const _hoisted_30 = {
  class: "flex-1 overflow-y-auto custom-scrollbar",
  style: {"max-height":"100%"}
}
const _hoisted_31 = { class: "py-2" }
const _hoisted_32 = { class: "flex-1" }
const _hoisted_33 = { class: "flex items-center" }
const _hoisted_34 = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-emerald-500 mr-3",
  style: {"box-shadow":"0 0 8px rgba(16, 185, 129, 0.6)"}
}
const _hoisted_35 = { class: "flex-1" }
const _hoisted_36 = { class: "flex items-center" }
const _hoisted_37 = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-emerald-500 mr-3",
  style: {"box-shadow":"0 0 8px rgba(16, 185, 129, 0.6)"}
}
const _hoisted_38 = { class: "bg-zinc-700/70 flex items-center justify-center w-10 h-10 rounded-full mr-4 group-hover:bg-red-500/20" }

import { onMounted, onUnmounted, ref, computed, watch } from 'vue'
import {
  ChartBarIcon,
  HomeIcon,
  CogIcon,
  UserIcon,
  CheckIcon
} from '@heroicons/vue/24/outline'
import { useRoute } from 'vue-router'
import {
  BotIcon,
  ChevronDown,
  ChevronRight,
  ClipboardIcon,
  Contact,
  CreditCardIcon,
  ExternalLink,
  Gift,
  GroupIcon,
  Headset,
  Instagram,
  KeyIcon,
  Link2,
  MessageCircle,
  MessageSquareMore,
  Package,
  Phone,
  Puzzle,
  RefreshCcw,
  Send,
  StepBack,
  StepForward,
  UserCog,
  Workflow,
  X,
  TrendingUp,
  LogOut,
  Wallet,
  UserCircle2
} from 'lucide-vue-next'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import { Toaster } from "@/components/ui/toast"
import { Toaster as SonnerToaster } from "vue-sonner"
import "vue-sonner/style.css"
import AdminLayoutNav from './components/AdminLayoutNav.vue'
import { useBot } from '@/composables/useBot'
import InstallPWADialog from '@/components/ui/pwa/InstallPWADialog.vue'
import { usePaymentGatewayIntegration } from '@/composables/usePaymentGatewayIntegration'
import WhatsappIcon from '@/components/ui/icons/WhatsappIcon.vue'
import { useOrganization } from '@/composables/useOrganization'
import UserProgressCard from './components/UserProgressCard.vue'
import { useAuth } from '@/composables/useAuth'
import { usePushNotification } from '@/composables/usePushNotification'

interface MenuItem {
  name: string;
  href: string;
  icon: any;
  current: boolean;
  hide?: boolean;
  new?: boolean;
  external?: boolean;
  section?: string;
}

// Menu Items

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLayout',
  setup(__props) {

const route = useRoute()

const { selectedBot } = useBot()
const { logout } = useAuth()
const { requestPermission, listenMessages } = usePushNotification()
const { isBetaTester } = useOrganization()
const { getOne: findOnePaymentGatewayIntegration, paymentGatewayIntegration } = usePaymentGatewayIntegration()
const isActive = (href: string) => route.name === href;

const isOpen = ref((localStorage.getItem('sidebarOpen') ?? 'true') === 'true')
const isMobile = ref(false)
const mobileMenuOpen = ref(false)

const handleLogout = () => {
    logout()
    window.location.href = '/login' // Force reload to clear state properly or use simple router push if available
}

const toggleSidebar = () => {
  isOpen.value = !isOpen.value
  localStorage.setItem('sidebarOpen', isOpen.value.toString())
}

const toggleDropdown = (dropdown: any) => {
  if (isOpen.value) {
    dropdown.open = !dropdown.open
  }
}

// Check if mobile on mount and window resize
const checkMobile = () => {
  isMobile.value = window.innerWidth < 1024
}

const menuItems: MenuItem[] = [
  { name: 'Início', href: 'home', icon: HomeIcon, current: true, hide: false },
  { name: 'Vendas', href: 'reports.consult-orders', icon: ChartBarIcon, hide: false, current: false },
  { name: 'Relatórios', href: 'reports.dashboard', icon: TrendingUp, hide: false, current: false },
  { name: 'Conversas', href: 'chats', icon: MessageCircle, current: false, hide: !selectedBot.value },
  { name: 'Fluxo de Chat', href: 'flows.manage', icon: Workflow, current: false, hide: !selectedBot.value, new: true },
  { name: 'Palavras chaves', href: 'leads.start-parameters', icon: KeyIcon, current: false, hide: !selectedBot.value },
];

const bottomMenuItems: MenuItem[] = [
  { name: 'Meu Perfil', href: 'profile', icon: UserCircle2, current: false },
  { name: 'Ajuda', href: 'help', icon: Headset, current: false },
]

// Mobile navigation items (limited to 4 for bottom nav)
const mobileNavItems = computed(() => {
  // Start with main menu items
  const items = [...menuItems]
  
  // Add most important items from dropdown (customize as needed)
  items.push(
    { name: 'Bots', href: 'bots.manage', icon: BotIcon, current: false },
    { name: 'Planos', href: 'payment-plans.manage', icon: CreditCardIcon, current: false },
  )
  
  // Limit to 4 items for mobile nav
  return items.slice(0, 4) as MenuItem[]
})

const menuDropdowns = ref<{ icon: any; name: string; open: boolean; children: MenuItem[] }[]>([
  {
    icon: Puzzle,
    name: 'Integrações',
    open: false, 
    children: [
      { name: 'Integrações', href: 'integrations', icon: Puzzle, current: false, hide: !selectedBot.value },
      { name: 'Gateways de Pagamento', href: 'payment-gateway-integrations.manage', icon: Wallet, current: false, hide: !selectedBot.value },
      { name: 'Links Utmify', href: 'utm-links.manage', icon: Link2, current: false, hide: !selectedBot.value },
    ] 
  },
  {
    icon: CogIcon,
    name: 'Configurações',
    open: false, 
    children: [
      { name: 'Bots', href: 'bots.manage', icon: BotIcon, current: false },
      { name: 'Grupos e canais', href: 'groups.manage', icon: GroupIcon, current: false, hide: !selectedBot.value },
      { name: 'Planos', href: 'payment-plans.manage', icon: CreditCardIcon, current: false, hide: !selectedBot.value },
      { name: 'Order Bumps', href: 'order-bumps.manage', icon: TrendingUp, current: false, hide: !selectedBot.value, new: true },
      { name: 'Vídeo Chamadas', href: 'video-calls.manage', icon: Phone, current: false, hide: !selectedBot.value, new: true },
      { name: 'Links de Redirecionamento', href: 'links.manage', icon: ClipboardIcon, current: false, hide: !selectedBot.value },
      { name: 'Packs', href: 'packages.manage', icon: Package, current: false, hide: !selectedBot.value },
      { name: 'Disparo de mensagens', href: 'messages.manage', icon: Send, current: false, hide: !selectedBot.value },
      { name: 'Usuários', href: 'leads.manage', icon: Contact, current: false, hide: !selectedBot.value },
      { name: 'Splits', href: 'my-account', icon: UserCog, current: false, hide: !selectedBot.value },
      { name: 'Afiliação', href: 'affiliation.manage', icon: Gift, current: false, hide: !paymentGatewayIntegration.value?.allowReferral },
    ] 
  }
])

// Combine all menu items into a single flat array with sections
const allMenuItems = computed(() => {
  const items: MenuItem[] = [
    ...menuItems,
    // Section divider
    { section: 'Integrações', name: '', href: '', icon: null, current: false, hide: !selectedBot.value },
    ...menuDropdowns.value[0].children,
    // Section divider
    { section: 'Configurações', name: '', href: '', icon: null, current: false },
    ...menuDropdowns.value[1].children,
  ];
  return items.filter(item => !item.hide);
})

// Close mobile menu when clicking outside or changing route
const handleRouteChange = () => {
  mobileMenuOpen.value = false
}

onMounted(() => {
  // Check if mobile on mount
  checkMobile()
  
  // Add event listener for window resize
  window.addEventListener('resize', checkMobile)
  
  // Watch for route changes to close mobile menu
  if (route) {
    watch(() => route.path, handleRouteChange)
  }
})

onMounted(async () => {
  await findOnePaymentGatewayIntegration()
})

onMounted(async () => {
  await requestPermission()
  await listenMessages()
})

// Clean up event listener
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(TooltipProvider), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("aside", {
          class: _normalizeClass([
          'fixed left-0 top-0 h-full border-r border-white/5 backdrop-blur-md py-4 pr-3 pl-3 flex flex-col transition-all duration-300 custom-scrollbar z-30 lg:block overflow-y-auto',
          isOpen.value ? 'w-64' : 'w-20',
          isMobile.value ? 'hidden' : '',
          'bg-zinc-900/80'
        ])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["mb-6 flex items-center", isOpen.value ? 'justify-between px-2' : 'justify-center'])
          }, [
            (isOpen.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_2))
              : (_openBlock(), _createElementBlock("img", _hoisted_3)),
            _createVNode(_unref(Tooltip), null, {
              default: _withCtx(() => [
                _createVNode(_unref(TooltipTrigger), { asChild: "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      onClick: toggleSidebar,
                      class: "bg-emerald-500/10 hover:bg-emerald-500/20 text-emerald-400 p-1.5 rounded-lg transition-all duration-200"
                    }, [
                      (!isOpen.value)
                        ? (_openBlock(), _createBlock(_unref(StepForward), {
                            key: 0,
                            class: "h-4 w-4"
                          }))
                        : (_openBlock(), _createBlock(_unref(StepBack), {
                            key: 1,
                            class: "h-4 w-4"
                          }))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(TooltipContent), null, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(isOpen.value ? 'Minimizar' : 'Expandir'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 2),
          (isOpen.value)
            ? (_openBlock(), _createBlock(UserProgressCard, {
                key: 0,
                class: "mb-4"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("nav", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allMenuItems.value, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.name
              }, [
                (!item.hide && !item.section)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_unref(Tooltip), {
                        "delay-duration": 300,
                        disabled: isOpen.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(TooltipTrigger), { asChild: "" }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(item.external ? 'a' : 'RouterLink'), _mergeProps({ ref_for: true }, item.external ? { href: item.href, target: '_blank', rel: 'noopener noreferrer' } : { to: { name: item.href } }, {
                                class: [
                      isActive(item.href)
                        ? 'bg-gradient-to-r from-emerald-500/20 to-emerald-500/5 text-white border-l-2 border-emerald-500'
                        : 'text-zinc-400 hover:bg-zinc-800/50 hover:text-white border-l-2 border-transparent',
                      'group flex items-center rounded-r-lg px-3 py-2 text-sm font-medium transition-all duration-200 relative',
                      isOpen.value ? '' : 'justify-center'
                    ]
                              }), {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                    class: _normalizeClass([
                        isActive(item.href) ? 'text-emerald-400' : 'text-zinc-400 group-hover:text-white',
                        'h-5 w-5 flex-shrink-0 transition-colors',
                        isOpen.value ? 'mr-3' : ''
                      ])
                                  }, null, 8, ["class"])),
                                  (isOpen.value)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass({ 'text-white font-medium': isActive(item.href) })
                                      }, _toDisplayString(item.name), 3))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1040, ["class"]))
                            ]),
                            _: 2
                          }, 1024),
                          (!isOpen.value)
                            ? (_openBlock(), _createBlock(_unref(TooltipContent), {
                                key: 0,
                                side: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", null, _toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["disabled"])
                    ]))
                  : (item.section && isOpen.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "h-px flex-1 bg-gradient-to-r from-transparent via-zinc-700/50 to-transparent" }, null, -1)),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(item.section), 1),
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "h-px flex-1 bg-gradient-to-r from-transparent via-zinc-700/50 to-transparent" }, null, -1))
                        ])
                      ]))
                    : (item.section && !isOpen.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[7] || (_cache[7] = [
                          _createElementVNode("div", { class: "h-px bg-zinc-700/50 mx-auto w-8" }, null, -1)
                        ])))
                      : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(bottomMenuItems, (item) => {
                return _createVNode(_unref(Tooltip), {
                  key: item.name,
                  "delay-duration": 300,
                  disabled: isOpen.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TooltipTrigger), { asChild: "" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(item.external ? 'a' : 'RouterLink'), _mergeProps({ ref_for: true }, item.external ? { href: item.href, target: '_blank', rel: 'noopener noreferrer' } : { to: { name: item.href } }, {
                          class: [
                      isActive(item.href)
                        ? 'bg-gradient-to-r from-emerald-500/20 to-emerald-500/5 text-white'
                        : 'text-zinc-400 hover:bg-zinc-800/50 hover:text-white',
                      'group flex items-center rounded-lg px-3 py-2 text-sm font-medium transition-all duration-200',
                      isOpen.value ? '' : 'justify-center'
                    ]
                        }), {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                              class: _normalizeClass([
                        isActive(item.href) ? 'text-emerald-400' : 'text-zinc-400 group-hover:text-white',
                        'h-5 w-5 flex-shrink-0 transition-colors',
                        isOpen.value ? 'mr-3' : ''
                      ])
                            }, null, 8, ["class"])),
                            (isOpen.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.name), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1040, ["class"]))
                      ]),
                      _: 2
                    }, 1024),
                    (!isOpen.value)
                      ? (_openBlock(), _createBlock(_unref(TooltipContent), {
                          key: 0,
                          side: "right"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, _toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["disabled"])
              }), 64)),
              _createVNode(_unref(Tooltip), {
                "delay-duration": 300,
                disabled: isOpen.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TooltipTrigger), { asChild: "" }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        onClick: handleLogout,
                        class: _normalizeClass([
                    'w-full group flex items-center rounded-lg px-3 py-2 text-sm font-medium transition-all duration-200 text-zinc-400 hover:bg-red-500/10 hover:text-red-400',
                    isOpen.value ? '' : 'justify-center'
                  ])
                      }, [
                        _createVNode(_unref(LogOut), {
                          class: _normalizeClass([
                      'h-5 w-5 flex-shrink-0 transition-colors text-zinc-400 group-hover:text-red-400',
                      isOpen.value ? 'mr-3' : ''
                    ])
                        }, null, 8, ["class"]),
                        (isOpen.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Sair"))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 1
                  }),
                  (!isOpen.value)
                    ? (_openBlock(), _createBlock(_unref(TooltipContent), {
                        key: 0,
                        side: "right"
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createElementVNode("p", null, "Sair", -1)
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            (isOpen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("a", _hoisted_15, [
                      _createVNode(_unref(Instagram), { class: "h-4 w-4 text-pink-400" })
                    ]),
                    _createElementVNode("a", _hoisted_16, [
                      _createVNode(WhatsappIcon, { class: "h-4 w-4 fill-emerald-400" })
                    ]),
                    _createElementVNode("a", _hoisted_17, [
                      _createVNode(_unref(Send), { class: "h-4 w-4 text-blue-400" })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!isOpen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_unref(Tooltip), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TooltipTrigger), { asChild: "" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_19, [
                            _createVNode(_unref(Instagram), { class: "h-4 w-4 text-pink-400" })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(TooltipContent), { side: "right" }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createElementVNode("p", null, "Instagram", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Tooltip), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TooltipTrigger), { asChild: "" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_20, [
                            _createVNode(WhatsappIcon, { class: "h-4 w-4 fill-emerald-400" })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(TooltipContent), { side: "right" }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createElementVNode("p", null, "WhatsApp", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Tooltip), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TooltipTrigger), { asChild: "" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_21, [
                            _createVNode(_unref(Send), { class: "h-4 w-4 text-blue-400" })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(TooltipContent), { side: "right" }, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createElementVNode("p", null, "Telegram", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileNavItems.value, (item, index) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(item.external ? 'a' : 'RouterLink'), _mergeProps({
                key: index,
                ref_for: true
              }, item.external ? { href: item.href, target: '_blank', rel: 'noopener noreferrer' } : { to: { name: item.href } }, {
                class: ["flex flex-col items-center justify-center px-2 py-1 rounded-lg transition-all duration-200 relative", [
                isActive(item.href) 
                  ? 'text-white' 
                  : 'text-zinc-400 hover:text-white'
              ]]
              }), {
                default: _withCtx(() => [
                  (isActive(item.href))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24))
                    : _createCommentVNode("", true),
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                    class: _normalizeClass(["h-6 w-6 mb-1", [
                  isActive(item.href) 
                    ? 'text-emerald-400' 
                    : 'text-zinc-400'
                ]])
                  }, null, 8, ["class"])),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1040, ["class"]))
            }), 128)),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = () => mobileMenuOpen.value = !mobileMenuOpen.value),
              class: _normalizeClass(["flex flex-col items-center justify-center px-2 py-1 rounded-lg transition-all duration-200 relative", [
              mobileMenuOpen.value 
                ? 'text-white' 
                : 'text-zinc-400 hover:text-white'
            ]])
            }, [
              (mobileMenuOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26))
                : _createCommentVNode("", true),
              _createVNode(_unref(CogIcon), {
                class: _normalizeClass(["h-6 w-6 mb-1", { 'text-emerald-400': mobileMenuOpen.value, 'text-zinc-400': !mobileMenuOpen.value }])
              }, null, 8, ["class"]),
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-xs font-medium" }, "Mais", -1))
            ], 2)
          ])
        ]),
        _createVNode(_Transition, { name: "slide-up" }, {
          default: _withCtx(() => [
            (mobileMenuOpen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "flex justify-center pt-3 pb-1" }, [
                      _createElementVNode("div", { class: "w-12 h-1.5 bg-zinc-600 rounded-full" })
                    ], -1)),
                    _createElementVNode("div", _hoisted_29, [
                      _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "text-xl font-bold text-white" }, "Menu", -1)),
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = () => mobileMenuOpen.value = false),
                        class: "flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 text-white shadow-lg",
                        style: {"box-shadow":"0 0 15px rgba(16, 185, 129, 0.3)"}
                      }, [
                        _createVNode(_unref(X), { class: "h-5 w-5" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuDropdowns.value[0].children, (item) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: item.name
                          }, [
                            (!item.hide)
                              ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.external ? 'a' : 'RouterLink'), {
                                  key: 0,
                                  to: !item.external ? { name: item.href } : null,
                                  href: item.external ? item.href : null,
                                  target: item.external ? '_blank' : null,
                                  rel: item.external ? 'noopener noreferrer' : null,
                                  class: _normalizeClass(["flex items-center px-6 py-4 text-zinc-100 hover:bg-zinc-700/50 transition-colors duration-200", { 'bg-gradient-to-r from-emerald-500/20 to-transparent': isActive(item.href) }]),
                                  onClick: _cache[2] || (_cache[2] = () => mobileMenuOpen.value = false)
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass([
                        isActive(item.href) 
                          ? 'bg-gradient-to-br from-emerald-500 to-teal-600' 
                          : 'bg-zinc-700/70',
                        'flex items-center justify-center w-10 h-10 rounded-full mr-4'
                      ]),
                                      style: _normalizeStyle(isActive(item.href) ? 'box-shadow: 0 0 10px rgba(16, 185, 129, 0.3);' : '')
                                    }, [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                        class: _normalizeClass([
                          isActive(item.href) ? 'text-white' : 'text-zinc-300',
                          'h-5 w-5'
                        ])
                                      }, null, 8, ["class"]))
                                    ], 6),
                                    _createElementVNode("div", _hoisted_32, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["text-base font-medium", { 'text-emerald-400': isActive(item.href) }])
                                      }, _toDisplayString(item.name), 3)
                                    ]),
                                    _createElementVNode("div", _hoisted_33, [
                                      (isActive(item.href))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_34))
                                        : _createCommentVNode("", true),
                                      (!item.external)
                                        ? (_openBlock(), _createBlock(_unref(ChevronRight), {
                                            key: 1,
                                            class: "h-5 w-5 text-zinc-500"
                                          }))
                                        : (_openBlock(), _createBlock(_unref(ExternalLink), {
                                            key: 2,
                                            class: "h-4 w-4 text-zinc-500"
                                          }))
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["to", "href", "target", "rel", "class"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuDropdowns.value[1].children, (item) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: item.name
                          }, [
                            (!item.hide)
                              ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.external ? 'a' : 'RouterLink'), {
                                  key: 0,
                                  to: !item.external ? { name: item.href } : null,
                                  href: item.external ? item.href : null,
                                  target: item.external ? '_blank' : null,
                                  rel: item.external ? 'noopener noreferrer' : null,
                                  class: _normalizeClass(["flex items-center px-6 py-4 text-zinc-100 hover:bg-zinc-700/50 transition-colors duration-200", { 'bg-gradient-to-r from-emerald-500/20 to-transparent': isActive(item.href) }]),
                                  onClick: _cache[3] || (_cache[3] = () => mobileMenuOpen.value = false)
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass([
                        isActive(item.href) 
                          ? 'bg-gradient-to-br from-emerald-500 to-teal-600' 
                          : 'bg-zinc-700/70',
                        'flex items-center justify-center w-10 h-10 rounded-full mr-4'
                      ]),
                                      style: _normalizeStyle(isActive(item.href) ? 'box-shadow: 0 0 10px rgba(16, 185, 129, 0.3);' : '')
                                    }, [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                        class: _normalizeClass([
                          isActive(item.href) ? 'text-white' : 'text-zinc-300',
                          'h-5 w-5'
                        ])
                                      }, null, 8, ["class"]))
                                    ], 6),
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["text-base font-medium", { 'text-emerald-400': isActive(item.href) }])
                                      }, _toDisplayString(item.name), 3)
                                    ]),
                                    _createElementVNode("div", _hoisted_36, [
                                      (isActive(item.href))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_37))
                                        : _createCommentVNode("", true),
                                      (!item.external)
                                        ? (_openBlock(), _createBlock(_unref(ChevronRight), {
                                            key: 1,
                                            class: "h-5 w-5 text-zinc-500"
                                          }))
                                        : (_openBlock(), _createBlock(_unref(ExternalLink), {
                                            key: 2,
                                            class: "h-4 w-4 text-zinc-500"
                                          }))
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["to", "href", "target", "rel", "class"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128)),
                        _createElementVNode("button", {
                          onClick: handleLogout,
                          class: "w-full flex items-center px-6 py-4 text-zinc-100 hover:bg-zinc-700/50 transition-colors duration-200 mt-2 border-t border-zinc-700/50"
                        }, [
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_unref(LogOut), { class: "h-5 w-5 text-zinc-300 group-hover:text-red-400" })
                          ]),
                          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex-1 text-left" }, [
                            _createElementVNode("span", { class: "text-base font-medium" }, "Sair")
                          ], -1))
                        ])
                      ])
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "h-4" }, null, -1))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (mobileMenuOpen.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "fixed inset-0 bg-black/70 backdrop-blur-sm z-40 lg:hidden",
                  onClick: _cache[4] || (_cache[4] = () => mobileMenuOpen.value = false)
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: _normalizeClass([
          isMobile.value ? 'pl-0 pb-16' : (isOpen.value ? 'pl-64' : 'pl-20'), 
          'transition-all duration-300'
        ])
        }, [
          _createVNode(AdminLayoutNav),
          _createElementVNode("div", {
            class: _normalizeClass([_unref(route).name === 'flows.show' ? '' : 'p-4 sm:p-6' ])
          }, [
            _createVNode(_component_router_view)
          ], 2)
        ], 2),
        _createVNode(InstallPWADialog)
      ]),
      _createVNode(_unref(Toaster)),
      _createVNode(_unref(SonnerToaster), {
        theme: "dark",
        position: "top-right"
      })
    ]),
    _: 1
  }))
}
}

})